export default __webpack_public_path__ + "static/media/Wicungo3.1bf3ae89.jpeg";